import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="px-4 md:px-6 max-w-[1200px] mx-auto py-12" aria-label="最新更新">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">最新更新</h2>
          <p className="text-sm text-foreground-500 mt-2">实时追踪你追的每一部漫画</p>
        </div>
        <Link to="/category/rexue" className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap">
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="bg-background-100 rounded-xl overflow-hidden">
        {latestUpdates.map((item, index) => (
          <Link
            key={`${item.id}-${item.chapterTitle}`}
            to={`/chapter/${item.id}/186`}
            className={`flex items-center justify-between px-5 py-4 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer ${
              index !== latestUpdates.length - 1 ? 'border-b border-background-200/70' : ''
            }`}
          >
            <div className="flex items-center gap-4 min-w-0">
              <span className={`text-xs font-bold w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 ${
                index < 3 ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </span>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground-900 truncate">{item.comicTitle}</p>
                <p className="text-xs text-foreground-500 truncate mt-0.5">{item.chapterTitle}</p>
              </div>
            </div>
            <span className="text-xs text-foreground-400 flex-shrink-0 ml-4 whitespace-nowrap">{item.time}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}